import { useState, useEffect } from "react";
import useAuth from "../hooks/useAuth";
import { useSelector, useDispatch } from "react-redux";
import {
  selectTabTrigger,
  setTabTrigger,
} from "../features/transformacije/PokreniTransformaciju";
import { selectCurrentToken } from "../features/auth/authSlice";
// import { useGetOneUserQuery } from "../features/users/usersApiSlice";
import { useGetAllNamirniceQuery } from "../features/Namirnice/namirniceApiSlice";
import { useGetAllMotivacijeQuery } from "../features/ciljevi/ciljeviApiSlice";
import { useNavigate } from "react-router-dom";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { useGetAllSpecCiljNamesQuery } from "../features/ciljevi/ciljeviApiSlice";
import GDPRConsentPopup from "../features/users/GDPRConsentPopup";

const DashFooter = () => {
  const dispatch = useDispatch();
  const tabTrigger = useSelector(selectTabTrigger);
  const {
    isSuccess: isSuccessGetNamir,
    isError: isErrorGetNamir,
    error: getNamirError,
    data: getNamirData,
  } = useGetAllNamirniceQuery();

  const {
    isSuccess: isSuccessGetMotiv,
    isError: isErrorGetMotiv,
    error: getMotivError,
    data: getMotivData,
  } = useGetAllMotivacijeQuery();

  const {
    isSuccess: isSuccessGetSpecCiljevi,
    isError: isErrorGetSpecCiljevi,
    error: getSpecCiljeviError,
    data: getSpecCiljeviData,
  } = useGetAllSpecCiljNamesQuery();

  const { isKlijent, id, email } = useAuth();
  const token = useSelector(selectCurrentToken);
  const navigate = useNavigate();

  const onGoTermsClicked = () => navigate("/terms");
  const onGoHelpClicked = () => navigate("/help");

  let {
    tezina,
    visina,
    pol,
    primcilj,
    specilj,
    godine,
    dijagnoza,
    ucestBr,
    navikeUish,
    kuk,
    vrat,
    struk,
    motiv,
    nivoAkt,
    vrstaFiz,
    alerg,
    pus,
    alk,
    datumRodjenja,
    namirnice,
    namirniceDa,
    voljeneNamirnice,
    neVoljeneNamirnice,
    ukupnaKalVred,
    selectedIshranaNaziv,
    tdee,
    bmi,
    krv,
    bmrValue,
    ime,
    prezime,
    imunitet,
    iskSaDijetama,
    intolerancija,
  } = useSelector((state) => state.transformacijaData);

  //Za prompt
  const [prompt, setPrompt] = useState(false);
  const [odg, setOdgovor] = useState();
  const [animacija, setAnimacija] = useState(false); //Animacija modal
  const [successChatData, setSuccessChatData] = useState(false);
  const [showNamirnicePopup, setShowNamirnicePopup] = useState(false);
  const [showSpecCiljPopup, setShowSpecCiljPopup] = useState(false);
  const [selectedValueBrDana, setSelectedValueBrDana] = useState(3);
  const [data_, setData] = useState({});
  const [availableNamirnice, setAvailableNamirnice] = useState([]); //
  const [availableMotivi, setAvailableMotivi] = useState([]);
  const [availableSpecCiljevi, setAvailableSpecCiljevi] = useState([]);
  const [verif, setVerif] = useState();

  //Za paket
  const [paketData, setPaketData] = useState();
  const [showPaketDataPopup, setShowPaketDataPopup] = useState(true);
  const vidiPretplate = () => navigate("/dash/sviPaketi");

  let closeAllModals = () => {
    setShowPaketDataPopup(false);
    closeModalIzmena();
  };

  //Za svaki slucaj se svi popupi zatvaraju...
  let showPretplate = () => {
    setShowPaketDataPopup(false);
    setAnimacija(false);
    setShowNamirnicePopup(false);
    setShowSpecCiljPopup(false);
    setPrompt(false);
    vidiPretplate();
  };

  let getStateVerif = async () => {
    try {
      const headers = new Headers();

      headers.set("Content-Type", "application/json");

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/getUserData/${id}`,
        {
          method: "GET",
          headers: headers,
          credentials: "include",
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();

      setVerif(result.isVerified);

      return result;
    } catch (error) {
      console.error("Error retrieving data:", error);
      //OVDE BI TREBALO DA SE DOBIJE PORUKA OD SERVERA AKO NEMA AKTIVNU
      alert("Problem sa uzimanjem user podataka sa servera! Osveži stranicu.");
    }
  };

  //Za sakrivanje footera - NZM ZASTO MI SE VODE LOADUJE
  // useEffect(() => {
  //   getStateVerif();
  // }, []);

  //Uzimamo sve naminice
  useEffect(() => {
    if (isSuccessGetNamir) {
      setAvailableNamirnice(Object.values(getNamirData.entities || {}));
      // console.log('Avalibe naminice: ', Object.values(getNamirData.entities))
    }

    if (isErrorGetNamir) {
      const errorMessage = getNamirError?.data?.message;
      alert(errorMessage);
    }
  }, [isSuccessGetNamir, isErrorGetNamir, getNamirError, getNamirData]);

  //Uzimamo sve motive
  useEffect(() => {
    if (isSuccessGetMotiv) {
      setAvailableMotivi(Object.values(getMotivData.entities || {}));
      // console.log('Avalibe motivi: ', Object.values(getMotivData.entities))
    }

    if (isErrorGetMotiv) {
      const errorMessage = getMotivError?.data?.message;
      alert(errorMessage);
    }
  }, [isSuccessGetMotiv, isErrorGetMotiv, getMotivError, getMotivData]);

  //Uzimamo sve specificne ciljeve - NEFETCHUJE
  useEffect(() => {
    if (isSuccessGetSpecCiljevi) {
      setAvailableSpecCiljevi(Object.values(getSpecCiljeviData.entities || {}));
      // console.log('Avalibe naminice: ', Object.values(getNamirData.entities))
    }

    if (isErrorGetSpecCiljevi) {
      const errorMessage = getSpecCiljeviError?.data?.message;
      alert(errorMessage);
    }
  }, [
    isSuccessGetSpecCiljevi,
    isErrorGetSpecCiljevi,
    getSpecCiljeviError,
    getSpecCiljeviData,
  ]);

  // useEffect(() => {
  //NEMA!
  // console.log("SPECIFICNI =>", availableSpecCiljevi);
  // }, [availableSpecCiljevi]);

  // Function to send data and trigger prompt modal
  const sendPitanje = async (e) => {
    e.preventDefault();
    console.log("Fethujemo chatGpt podatke!");

    // if (namirnice.length === 0) {
    //     alert("Izaberite neku ishranu");
    //     return;
    // }

    // if (isNaN(ukupnaKalVred)) {
    //   alert("Izaberite nivo aktivnosti");
    //   return;
    // }

    setPrompt(false);
    setAnimacija(true);

    let promptText = "";

    //Postavi da su velika slova iz preglednosti
    // ucestBr = capitalizeFirstLetter(ucestBr)

    // function pretvoriIntolerancijeUString(intolerancije) {
    //   return intolerancije.join(", ");
    // }

    // let intolerancije = pretvoriIntolerancijeUString(intolerancija)

    //let data_ = { id, tezina, visina, pol, primcilj, specilj, godine, dijagnoza, ucestBr, navikeUish, namirnice, voljeneNamirnice, neVoljeneNamirnice, ukupnaKalVred, selectedValueBrDana, tdee, bmi, kuk,vrat,struk,motiv,nivoAkt,vrstaFiz,alerg,pus,alk,datumRodjenja, selectedIshranaNaziv, krv, bmrValue, ime, prezime, email, imunitet, iskSaDijetama, intolerancije }

    // const obroci = ucestBr?.split(',').map(item => item.trim())
    let obroci_ = data_?.ucestBr.split(", "); //Prebacujem u listu jer odgovara serveru

    //bio je prompts, test1 je pravi a test2 je testni
    const res = await fetch(`${process.env.REACT_APP_API_URL}/test2`, {
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        data_,
        brojDana: selectedValueBrDana,
        obroci: obroci_,
      }),
      method: "POST",
    });

    const data = await res.json();
    // console.log("Odgovor", data);

    if (data !== null) {
      setSuccessChatData(true);
    }

    setOdgovor(data.description);
  };

  // Function to close modal
  const closeModalIzmena = () => {
    setPrompt(false);
    setAnimacija(false);
    setSuccessChatData(false);
  };

  const setTrigg = () => {
    //here
    dispatch(setTabTrigger(!tabTrigger));
    setSuccessChatData(false);
    setAnimacija(false);
  };

  const handleChangeBrDana = (event) => {
    setSelectedValueBrDana(event.target.value);
  };

  const capitalizeFirstLetter = (text) => {
    return text
      ?.split(", ")
      .map((item) => item.charAt(0).toUpperCase() + item.slice(1))
      .join(", ");
  };

  //Otvara window i fetchuje (usera) podatke od servera
  //OVDE KADA SE FETCHUJU SVI PODACI O USERU DA SE PRIKAZE MALI WARNING POPUP KOJI NAS OBAVESTAVA DA NENAMO UPLACENI PAKET!!!
  //POPUP TREBA DA BUDE MANJI I PREKO PRVOG POPUPA, TREBA DA MOZE DA SE ISKLJUCI ALI DA SE DISEJBLUJE DUGME ZA KREIRANJE!!!
  //SVAKAKO PRIKAZI TAJ POPUP IAKO IMA U PAKETU I KOLIKO JOS PUTA!!!
  let openWindow = async () => {
    setShowPaketDataPopup(true);
    //Uzimamo podatke
    try {
      const headers = new Headers();
      // if (token) {
      //   headers.set("Authorization", `Bearer ${token}`);
      // }
      headers.set("Content-Type", "application/json");

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/getUserData/${id}`,
        {
          method: "GET",
          headers: headers,
          credentials: "include",
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      console.log("Data retrieved successfully:", result);
      setPrompt(true);

      //Prebacujemo iz id u naziv naminice, oba samo traze
      const naminice_naziviDa = availableNamirnice
        .filter((obj) => result?.user.namirniceDa.includes(obj._id))
        .map((obj) => obj.naziv);
      const naminice_nazivi = availableNamirnice
        .filter((obj) => result?.user.namirnice.includes(obj._id))
        .map((obj) => obj.naziv);

      // console.log('Namirnice => ', naminice_nazivi);
      // console.log('NamirniceDa => ', naminice_naziviDa);

      // console.log("user => ", result.user);

      result.user.namirniceDa = naminice_naziviDa;
      result.user.namirnice = naminice_nazivi;
      // result.user.specilj = specCiljevi;

      const nazivMotiva = availableMotivi.find(
        (obj) => obj._id === result?.user.motiv
      )?.naziv;

      result.user.motiv = nazivMotiva;

      setData(result.user);
      setPaketData(result.paket);
      // console.log("Iz popupa: ", result.paket);

      // console.log("Active paket from database => ", result.paket);

      return result;
    } catch (error) {
      console.error("Error retrieving data:", error);
      alert("Problem sa uzimanjem user podataka sa servera! Osveži stranicu.");
    }
  };

  // <footer className="fixed inset-x-0 bottom-0 z-50 bg-veljko-blue w-full p-2 flex items-center justify-between" style={{ backgroundColor: "#66BB6A" }}>
  //   <div className="flex items-center justify-between w-full">
  //     {/* <button className="bg-white text-veljko-blue p-1 rounded">Blog</button> */}
  //     <button></button>
  //     {/* <button className="bg-white text-veljko-blue p-1 rounded mx-2" onClick={() => setPrompt(true)}>
  //       Pokreni svoju transformaciju
  //     </button> */}
  //     <button className="bg-white text-veljko-blue p-1 rounded mx-2" onClick={openWindow}>
  //       Pokreni svoju transformaciju
  //     </button>
  //     {/* <button className="bg-white text-veljko-blue p-1 rounded">Uputstva</button> */}
  //     <button></button>
  //   </div>
  // </footer>

  const nivoiFizickihAktivnosti = {
    sedentarni: {
      naziv: "Sedentaran",
      faktorAktivnosti: 1.2,
    },
    laganaAktivnost: {
      naziv: "Lagano aktivan",
      faktorAktivnosti: 1.375,
    },
    umerenaAktivnost: {
      naziv: "Umereno aktivan",
      faktorAktivnosti: 1.55,
    },
    intenzivnaAktivnost: {
      naziv: "Veoma aktivan",
      faktorAktivnosti: 1.725,
    },
    vrloIntenzivnaAktivnost: {
      naziv: "Ekstremno aktivan",
      faktorAktivnosti: 1.9,
    },
  };

  function getNivoFizickeAktivnosti(faktorAktivnosti) {
    if (typeof faktorAktivnosti === "string") {
      faktorAktivnosti = parseFloat(faktorAktivnosti);
    }
    for (let nivo in nivoiFizickihAktivnosti) {
      if (nivoiFizickihAktivnosti[nivo].faktorAktivnosti === faktorAktivnosti) {
        return nivoiFizickihAktivnosti[nivo].naziv;
      }
    }
    return "Nepoznat nivo aktivnosti"; // Ako faktor aktivnosti nije pronađen
  }

  // function animateButton() {
  //   const button = document.querySelector(".circle-button");
  //   button.classList.add("scale-[0.95]", "border-4", "border-yellow-500");

  //   setTimeout(() => {
  //     button.classList.remove("scale-[0.95]", "border-4", "border-yellow-500");
  //   }, 200);
  // }

  function animateButton() {
    const button = document.querySelector(".circle-button");
    if (button) {
      button.classList.add("scale-[0.95]", "border-4", "border-red-500");

      setTimeout(() => {
        button.classList.remove("scale-[0.95]", "border-4", "border-red-500");
      }, 200);
    } else {
      console.warn("Button not found");
    }
  }

  // const oldFooter = (
  //   <footer
  //     className="fixed inset-x-0 bottom-0 z-50 bg-veljko-blue w-full flex flex-col items-center justify-between overflow-visible"
  //     style={{ backgroundColor: "#66BB6A" }}
  //   >
  //     {/* Ovaj div sada je gore */}
  //     <div className="flex items-center justify-between w-full relative">
  //       <button className=""></button>

  //       <div
  //         className="relative w-full h-12 cursor-pointer"
  //         onClick={openWindow}
  //       >
  //         <img
  //           src={`${process.env.PUBLIC_URL}/img/LogoNTrans.png`}
  //           alt="Ikona"
  //           className="absolute left-1/2 transform -translate-x-1/2 -top-4 h-16 z-50"
  //           style={{
  //             position: "absolute",
  //             bottom: "-10px",
  //           }}
  //         />
  //       </div>
  //       <button className=""></button>
  //     </div>
  //     <GDPRConsentPopup />
  //   </footer>
  // );

  // const newFooter = (
  //   <footer className="footer">
  //     <div className="circle">
  //       <button onClick={animateButton} className="circle-button"></button>
  //     </div>
  //   </footer>
  // );

  //Za highlighting
  const [highlighted, setHighlighted] = useState(false);
  // Toggle za highlight
  // const toggleHighlight = () => setHighlighted((prev) => !prev);

  // Cuvam da ne bi zeznuo
  // let currentFooter = (
  //   <>
  //     {prompt === true || verif == false ? (
  //       ""
  //     ) : (
  //       <footer
  //         className="fixed inset-x-0 bottom-0 text-white p-5 text-center w-full"
  //         style={{
  //           zIndex: 2,
  //           // backgroundColor: highlighted ? "#f1f1f1" : "white",
  //           // borderRadius: "8px",
  //           boxShadow: highlighted ? "0px 8px 15px rgba(0, 0, 0, 0.1)" : "none",
  //           transition: "all 0.3s ease",
  //           backgroundColor: "#66BB6A",
  //         }}
  //       >
  //         {/* NT PUSL DUGME */}
  //         <div
  //           className="w-[80px] h-[80px] bg-green-500 rounded-full absolute bottom-0 left-1/2 transform -translate-x-1/2 flex justify-center items-center"
  //           style={{ backgroundColor: "#66BB6A" }}
  //         >
  //           <button
  //             onClick={animateButton}
  //             className="w-[70%] h-[70%] bg-[#3b3838] rounded-full border-none text-[#ecd0d0] font-normal cursor-pointer text-center flex justify-center items-center animate-pulsiranje bg-cover"
  //           >
  //             <img
  //               src={`${process.env.PUBLIC_URL}/img/nutriLogo.png`}
  //               onClick={openWindow}
  //             />
  //           </button>
  //         </div>

  {
    /* <button
          onClick={toggleHighlight}
          style={{
            padding: "20px",
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            zIndex: 2,
            position: "relative",
            backgroundColor: highlighted ? "#f1f1f1" : "white",
            boxShadow: highlighted
              ? "0px 8px 15px rgba(0, 0, 0, 0.1)"
              : "none",
            transition: "all 0.3s ease",
          }}
        >
          {highlighted ? "Remove Highlight" : "Highlight"}
        </button> */
  }
  {
    /* </footer>
      )}
    </>
  ); */
  }

  return (
    <>
      {/* Footer */}
      {isKlijent ? (
        <>
          {prompt === true || verif == false ? (
            ""
          ) : (
            <footer
              className="fixed inset-x-0 bottom-0 z-50 w-full px-2 sm:px-4 md:px-6 lg:px-8 pb-3 sm:pb-2"
              style={{
                zIndex: 2,
                // backgroundColor: highlighted ? "#f1f1f1" : "white",
                // borderRadius: "8px",
                boxShadow: highlighted
                  ? "0px 8px 15px rgba(0, 0, 0, 0.1)"
                  : "none",
                transition: "all 0.3s ease",
                backgroundColor: "#66BB6A",
                paddingBottom: "0px",
              }}
            >
              <div className="flex flex-wrap items-center justify-between gap-2 sm:gap-4 md:gap-6">
                {/* Leva strana - Link (smanjuje se na manjim ekranima) */}
                <button
                  onClick={onGoHelpClicked}
                  className="text-white text-xs"
                  style={{
                    border: "1px dashed #fff",
                    borderRadius: "5px",
                    padding: "1px",
                  }}
                >
                  Pomoć
                </button>

                {/* Središnja komponenta - Fleksibilno centrirana */}
                <div className="flex-1 flex flex-col items-center">
                  {/* NT PUSL DUGME - work here */}
                  <div
                    className="w-[80px] h-[80px] bg-green-500 rounded-full absolute bottom-0 left-1/2 transform -translate-x-1/2 flex justify-center items-center"
                    style={{ backgroundColor: "#66BB6A" }}
                  >
                    <button
                      onClick={animateButton}
                      className="circle-button w-[70%] h-[70%] bg-[#3b3838] rounded-full border-none text-[#ecd0d0] font-normal cursor-pointer text-center flex justify-center items-center animate-pulsiranje bg-cover"
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/img/nutriLogo.png`}
                        onClick={openWindow}
                      />
                    </button>
                  </div>
                </div>

                {/* Desna strana - Link (smanjuje se na manjim ekranima) */}
                <a
                  onClick={onGoTermsClicked}
                  className="text-white text-xs text-center md:inline-block block cursor-pointer"
                  style={{
                    border: "1px dashed #fff",
                    borderRadius: "5px",
                    padding: "1px",
                  }}
                >
                  Uslovi <br /> korišćenja
                </a>
              </div>
            </footer>
          )}
        </>
      ) : (
        <footer
          className="fixed inset-x-0 bottom-0 z-50 bg-veljko-blue w-full p-2 flex items-center justify-between"
          style={{ backgroundColor: "#66BB6A" }}
        >
          <div className="flex items-center justify-between w-full">
            <button className="bg-white text-veljko-blue p-1 rounded">1</button>
            <button className="bg-white text-veljko-blue p-1 rounded mx-2">
              2
            </button>
            <button className="bg-white text-veljko-blue p-1 rounded">3</button>
          </div>
        </footer>
      )}

      {/* Modal for prompt */}
      {prompt && (
        <>
          <div
            className="z-40 fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center p-4"
            onClick={closeModalIzmena}
          >
            <div
              className="relative w-full max-w-md max-h-[90vh] p-4 bg-white rounded-lg shadow-lg overflow-y-auto"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="text-center">
                <h3 className="text-base font-semibold text-[#66BB6A] mb-3">
                  Podaci za kreiranje ishrane
                </h3>

                <table className="min-w-full mb-4 border-collapse text-sm">
                  <tbody>
                    <tr className="bg-[#66BB6A] bg-opacity-20">
                      <td className="font-medium p-2">Težina:</td>
                      <td className="p-2">
                        {data_?.tezina ? `${data_?.tezina} kg` : "Nema"}
                      </td>
                    </tr>
                    <tr className="bg-white">
                      <td className="font-medium p-2">Visina:</td>
                      <td className="p-2">
                        {data_?.visina ? `${data_?.visina} cm` : "Nema"}
                      </td>
                    </tr>
                    <tr className="bg-[#66BB6A] bg-opacity-20">
                      <td className="font-medium p-2">Pol:</td>
                      <td className="p-2">{data_?.pol || "Nema"}</td>
                    </tr>
                    <tr className="bg-white">
                      <td className="font-medium p-2">Godine:</td>
                      <td className="p-2">{data_?.godine || "Nema"}</td>
                    </tr>
                    <tr className="bg-[#66BB6A] bg-opacity-20">
                      <td className="font-medium p-2">Kalorijska vrednost:</td>
                      <td className="p-2">
                        {Math.round(data_?.ukupnaKalVred)} kalorija/dan
                      </td>
                    </tr>
                    <tr className="bg-white">
                      <td className="font-medium p-2">Nivo aktivnosti:</td>
                      <td className="p-2">
                        {getNivoFizickeAktivnosti(data_?.nivoAkt)}
                      </td>
                    </tr>
                    <tr className="bg-[#66BB6A] bg-opacity-20">
                      <td className="font-medium p-2">Tip ishrane:</td>
                      <td className="p-2">
                        {data_?.selectedIshranaNaziv || "Nema"}
                      </td>
                    </tr>
                    <tr className="bg-white">
                      <td className="font-medium p-2">Primaran cilj:</td>
                      <td className="p-2">{data_?.primcilj}</td>
                    </tr>
                    {/* <tr className="bg-[#66BB6A] bg-opacity-20">
                      <td className="font-medium p-2">Spec cilj:</td>
                      <td className="p-2">{specilj}</td>
                    </tr> */}
                    <tr className="bg-[#66BB6A] bg-opacity-20">
                      <td className="font-medium p-2">Motiv:</td>
                      <td className="p-2">{data_?.motiv || "Nema"}</td>
                    </tr>
                    <tr className="bg-white">
                      <td className="font-medium p-2">Učestalost obroka:</td>
                      <td className="p-2">
                        {capitalizeFirstLetter(data_?.ucestBr) || "Nema"}
                      </td>
                    </tr>
                    <tr className="bg-[#66BB6A] bg-opacity-20">
                      <td className="font-medium p-2">Namirnice:</td>
                      <td className="p-2">
                        {data_?.namirniceDa.length > 0 ? (
                          <button
                            onClick={() => setShowNamirnicePopup(true)}
                            className="text-blue-600 underline text-sm"
                          >
                            Vidi namirnice
                          </button>
                        ) : (
                          "Nema odabranih namirnica"
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <h3 className="mt-2 text-base font-semibold text-[#66BB6A]">
                  Na koliko dana je plan ishrane?
                </h3>

                <select
                  value={selectedValueBrDana}
                  onChange={handleChangeBrDana}
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 text-sm sm:leading-6 mb-4"
                >
                  <option value={3}>3</option>
                  <option value={7}>7</option>
                </select>

                {paketData?.broj.full > 0 ? (
                  <>
                    <h3 className="mt-2 text-base font-semibold text-[#66BB6A]">
                      Da li ste sigurni da želite da napravite?
                    </h3>

                    <div className="mt-4 flex justify-between gap-4">
                      <button
                        onClick={closeModalIzmena}
                        className="px-6 py-3 bg-gray-300 text-gray-900 text-lg font-bold rounded-lg shadow-lg hover:bg-gray-400 transition duration-300 w-full"
                      >
                        Zatvori
                      </button>
                      {/* Dugme koje IMA zastitu SAMO ODKOMENTARISI OVO I POSTAVI U BAZI AKTIVNE*/}
                      {/* <button
                    onClick={sendPitanje}
                    className={`px-6 py-3 text-white text-lg font-bold rounded-lg shadow-lg transition duration-300 w-full ${paketData ? 'bg-[#66BB6A] hover:bg-[#5FAE5C]' : 'bg-gray-400 cursor-not-allowed'}`}
                    disabled={!paketData}
                  >
                    Napravi
                  </button> */}

                      {/* Dugme koje NEMA zastitu SAMO ODKOMENTARISI OVO I POSTAVI U BAZI AKTIVNE*/}
                      <button
                        onClick={sendPitanje}
                        className="px-6 py-3 text-white text-lg font-bold rounded-lg shadow-lg transition duration-300 w-full bg-[#66BB6A] hover:bg-[#5FAE5C]"
                      >
                        Napravi
                      </button>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>

          {/* Odkomentarisi sve ovo da bi se vide popup */}
          {showPaketDataPopup && (
            <div className="fixed inset-0 bg-gray-500 bg-opacity-50 inset-0 flex items-center justify-center z-50">
              <div className="p-2 lg:w-1/5 lg:max-w-md lg:shrink-0">
                <div className="rounded-2xl bg-gray-50 py-2 text-center ring-1 ring-inset ring-gray-900/5 lg:flex lg:flex-col lg:justify-center">
                  <div className="mx-auto max-w-xs px-8">
                    {paketData ? (
                      <>
                        {/* Kada IMA aktivnu pretplatu */}
                        {paketData?.broj.full > 0 ? (
                          <>
                            <p className="text-base font-semibold text-gray-600">
                              Preostalo izveštaja
                            </p>
                            <p className="mt-3 flex items-baseline justify-center gap-x-2">
                              <div className="w-16 h-16 text-black flex flex-col items-center justify-center font-semibold rounded-2xl ring-1 ring-gray-200">
                                {paketData?.broj.full}
                              </div>
                            </p>

                            <button
                              onClick={() => setShowPaketDataPopup(false)}
                              className="mt-3 block w-full rounded-md bg-green-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                            >
                              Uredu
                            </button>
                          </>
                        ) : (
                          <>
                            <p className="text-base font-semibold text-red-600 text-center">
                              Nemate više izveštaja!
                            </p>
                            <div className="flex space-x-4">
                              <button
                                onClick={showPretplate}
                                className="mt-3 rounded-md bg-green-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                              >
                                Kupite ovde
                              </button>
                              <button
                                onClick={() => closeAllModals()}
                                className="mt-3 rounded-md bg-red-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                              >
                                Ugasi
                              </button>
                            </div>
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        {/* Kada NEMA aktivnu pretplatu */}
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 mx-auto max-w-xs px-8 flex flex-col items-center justify-center">
                          <ExclamationTriangleIcon
                            className="h-16 w-16 shrink-0 cursor-pointer stroke-red-600"
                            aria-hidden="true"
                          />
                          <p className="text-base font-semibold text-red-600 text-center">
                            Nemate aktivan paket!
                          </p>
                          <div className="flex space-x-4">
                            <button
                              onClick={showPretplate}
                              className="mt-3 rounded-md bg-green-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                            >
                              Kupite ovde
                            </button>
                            <button
                              onClick={() => closeAllModals()}
                              className="mt-3 rounded-md bg-red-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                            >
                              Ugasi
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {/* {showPaketDataPopup && (
    <div className="fixed inset-0 flex items-center justify-center z-50">
        <div className="p-2 lg:w-1/5 lg:max-w-md lg:shrink-0">
            <div className="rounded-2xl bg-gray-50 py-2 text-center ring-1 ring-inset ring-gray-900/5 lg:flex lg:flex-col lg:justify-center">
                <div className="mx-auto max-w-xs px-8">
                    <p className="text-base font-semibold text-gray-600">Preostalo izveštaja</p>
                    <p className="mt-3 flex items-baseline justify-center gap-x-2">
                        <div className="w-16 h-16 text-black flex flex-col items-center justify-center font-semibold rounded-2xl ring-1 ring-gray-200">
                            <p className="text-xs font-semibold text-black">Full</p>
                            1
                        </div>
                        <div className="w-16 h-16 text-black flex flex-col items-center justify-center font-semibold rounded-2xl ring-1 ring-gray-200">
                            <p className="text-xs font-semibold text-black">Osnovni</p>
                            2
                        </div>
                    </p>
                    <a href="#" className="mt-3 block w-full rounded-md bg-red-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600">
                        Deaktiviraj
                    </a>
                </div>
            </div>
        </div>
    </div>
)} */}

      {showNamirnicePopup && (
        <div
          className="z-50 fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center"
          onClick={() => setShowNamirnicePopup(false)}
        >
          <div
            className="relative p-4 border w-96 max-h-[80vh] overflow-y-auto shadow-lg rounded-lg bg-white"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="text-lg font-semibold text-[#66BB6A]">
              Izabrane namirnice
            </h3>

            <h4 className="mt-4 font-semibold">
              Uklonjene namirnice iz izabrane ishrane:
            </h4>
            <ul className="mt-1">
              {data_?.namirnice.map((namirnica, index) => (
                <li key={index} className="p-1 border-b">
                  {index + 1}. {namirnica}
                </li>
              ))}
            </ul>

            <h4 className="mt-4 font-semibold">
              Namirnice koje pripadaju izabrenoj ishrani:
            </h4>
            <ul className="mt-1">
              {data_?.namirniceDa.map((namirnica, index) => (
                <li key={index} className="p-1 border-b">
                  {index + 1}. {namirnica}
                </li>
              ))}
            </ul>

            <h4 className="mt-4 font-semibold">Voljene namirnice:</h4>
            <p className="mt-1">
              {capitalizeFirstLetter(data_?.voljeneNamirnice) ||
                "Nema voljenih namirnica"}
            </p>

            <h4 className="mt-4 font-semibold">Ne voljene namirnice:</h4>
            <p className="mt-1">
              {capitalizeFirstLetter(data_?.neVoljeneNamirnice) ||
                "Nema ne voljenih namirnica"}
            </p>

            <div className="mt-2">
              <button
                onClick={() => setShowNamirnicePopup(false)}
                className="mt-3 px-4 py-2 bg-gray-200 text-gray-800 text-base font-medium rounded-lg w-full shadow-sm border border-gray-300 hover:bg-gray-300 transition duration-300"
              >
                Zatvori
              </button>
            </div>
          </div>
        </div>
      )}

      {showSpecCiljPopup && (
        <div
          className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center"
          onClick={() => setShowSpecCiljPopup(false)}
        >
          <div
            className="relative p-4 border w-96 max-h-[80vh] overflow-y-auto shadow-lg rounded-lg bg-white"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="text-lg font-semibold text-[#66BB6A]">
              Izabrani specifični ciljevi
            </h3>

            <ul className="mt-1">
              {specilj.map((spec, index) => (
                <li key={index} className="p-1 border-b">
                  {index + 1}. {spec}
                </li>
              ))}
            </ul>

            <div className="mt-2">
              <button
                onClick={() => setShowSpecCiljPopup(false)}
                className="mt-3 px-4 py-2 bg-gray-200 text-gray-800 text-base font-medium rounded-lg w-full shadow-sm border border-gray-300 hover:bg-gray-300 transition duration-300"
              >
                Zatvori
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Animation Modal */}
      {/* {animacija && (
        <div
          className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center"
          onClick={closeModalIzmena}
        >
          <div
            className="relative p-2 border w-80 shadow-lg rounded bg-white"
            onClick={(e) => e.stopPropagation()}
          >
  
            <div className="text-center">
              <h3 className="mb-4" style={{ fontSize: "14px" }}>
                🍽️ Pripremamo Vaš personalizovani jelovnik! 🍽️
              </h3>
              {successChatData === false ? (
                <img
                  src={`${process.env.PUBLIC_URL}/animacija1.gif`}
                  alt="Loading animation"
                  className="my-4"
          
                />
              ) : (
                <>
                  <h3>Uspešno kreirana ishrana, možete je videti</h3>
                  <button
                    onClick={setTrigg}
                    style={{
                      textDecoration: "underline",
                      color: "blue",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "red")}
                    onMouseLeave={(e) => (e.target.style.color = "blue")}
                  >
                    klikom ovde
                  </button>
                </>
              )}
              <h3 className="mb-4" style={{ fontSize: "14px" }}>
                Pravljenje izveštaja traje 3-5 minuta – naš virtuelni kuvar
                marljivo radi na tome! 👨‍🍳🔥 ✅ Možete ostati na ovoj stranici
                ili izaći iz aplikacije – obaveštenje će stići na vaš email. ✅
                Izveštaj će vas čekati u sekciji "Planovi ishrane" kada se
                vratite u aplikaciju. Hvala na strpljenju! Vaš plan ishrane
                stiže uskoro. ⏳✨
              </h3>
            </div>
          </div>
        </div>
      )} */}
      {animacija && (
        <div
          className="z-40 fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center"
          onClick={closeModalIzmena}
        >
          <div
            className="relative p-4 border w-80 shadow-lg rounded bg-white"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="text-center">
              <h3 className="mb-4 text-sm">
                🍽️ Pripremamo Vaš personalizovani jelovnik! 🍽️
              </h3>

              {/* Conditional rendering based on successChatData */}
              {successChatData === false ? (
                <img
                  src={`${process.env.PUBLIC_URL}/animacija1.gif`}
                  alt="Loading animation"
                  className="my-4"
                />
              ) : (
                <>
                  <h3 className="mb-0 underline decoration-green-500">
                    Uspešno kreirana ishrana, možete je videti
                  </h3>
                  <button
                    onClick={setTrigg}
                    className="text-blue-500 underline"
                    onMouseEnter={(e) => (e.target.style.color = "red")}
                    onMouseLeave={(e) => (e.target.style.color = "blue")}
                  >
                    klikom ovde
                  </button>
                </>
              )}

              <p className="mt-2 text-sm">
                Pravljenje izveštaja traje 3-5 minuta – naš virtuelni kuvar
                marljivo radi na tome! 👨‍🍳🔥
              </p>

              <p className="mt-2 text-sm">
                ✅ Možete ostati na ovoj stranici ili izaći iz aplikacije –
                obaveštenje će stići na vaš email.
              </p>

              <p className="mt-2 text-sm">
                ✅ Izveštaj će vas čekati u sekciji "Planovi ishrane" kada se
                vratite u aplikaciju.
              </p>

              <p className="mt-2 text-sm">
                Hvala na strpljenju! Vaš plan ishrane stiže uskoro. ⏳✨
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DashFooter;

{
  /* <div className="grid grid-cols-8 gap-4">
<div><img src={`${process.env.PUBLIC_URL}/img/s6.png`} alt="Slika 1" className="w-36 h-auto"/></div>
<div><img src={`${process.env.PUBLIC_URL}/img/s4.png`} alt="Slika 2" className="w-36 h-auto"/></div>
<div><img src={`${process.env.PUBLIC_URL}/img/s3.png`} alt="Slika 3" className="w-36 h-auto"/></div>
<div><img src={`${process.env.PUBLIC_URL}/img/s7.png`} alt="Slika 4" className="w-36 h-auto"/></div>
<div><img src={`${process.env.PUBLIC_URL}/img/s1.png`} alt="Slika 5" className="w-36 h-auto"/></div>
<div><img src={`${process.env.PUBLIC_URL}/img/s2.png`} alt="Slika 6" className="w-36 h-auto"/></div>
<div><img src={`${process.env.PUBLIC_URL}/img/s5.png`} alt="Slika 7" className="w-36 h-auto"/></div>
<div><img src={`${process.env.PUBLIC_URL}/img/s8.jpg`} alt="Slika 8" className="w-36 h-auto"/></div>
</div> */
}

{
  /* <p className="mt-4 text-sm">
Pravljenje izveštaja traje 3-5 minuta – naš virtuelni kuvar
marljivo radi na tome! 👨‍🍳🔥 ✅ Možete ostati na ovoj stranici
ili izaći iz aplikacije – obaveštenje će stići na vaš email. ✅
Izveštaj će vas čekati u sekciji "Planovi ishrane" kada se
vratite u aplikaciju. Hvala na strpljenju! Vaš plan ishrane
stiže uskoro. ⏳✨
</p> */
}
